import { Avatar } from '@/design-system';
import type { Role, SessionTenant } from '@/shared/api';
import { cn } from '@/shared/lib';

import { rolesLabel } from './copy';

export interface TenantBadgeProps {
    tenant: Pick<SessionTenant, 'name' | 'logoUrl'>;
    roles: readonly Role[];
    onDark?: boolean;
    className?: string;
}

/**
 * In welke omgeving zit je? Naam en logo van het bedrijf, met de rol eronder.
 *
 * Iemand die voor drie bedrijven werkt en per ongeluk een keuring bij het
 * verkeerde bedrijf opvoert is een echt probleem; daarom staat dit zichtbaar
 * in het gebruikersblok en niet weggestopt in een menu.
 */
export function TenantBadge({ tenant, roles, onDark = false, className }: TenantBadgeProps) {
    return (
        <span className={cn('inline-flex min-w-0 items-center gap-[9px]', className)}>
            {tenant.logoUrl ? (
                <img
                    src={tenant.logoUrl}
                    alt=""
                    className="h-7 w-7 shrink-0 rounded-[5px] object-contain"
                />
            ) : (
                <Avatar size={28} variant="placeholder" />
            )}
            <span className="min-w-0">
                <span
                    className={cn(
                        'block truncate text-[13px] leading-[1.3] font-medium',
                        onDark ? 'text-[var(--text-on-dark)]' : 'text-[var(--text-primary)]',
                    )}
                >
                    {tenant.name}
                </span>
                <span
                    className={cn(
                        'block truncate text-[11px] leading-[1.3]',
                        onDark
                            ? 'text-[var(--text-on-dark-4-safe)]'
                            : 'text-[var(--text-tertiary-safe)]',
                    )}
                >
                    {rolesLabel(roles)}
                </span>
            </span>
        </span>
    );
}
